// src/components/Product/SizeSelectionDialog.js
import React from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  Typography,
  Box,
  IconButton
} from '@mui/material';
import { Close } from '@mui/icons-material';

const SizeSelectionDialog = ({
  open,
  onClose,
  availableSizes,
  selectedSize,
  onSizeChange,
  onAddToCart
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm" 
      fullWidth
      sx={{ 
        '& .MuiDialog-paper': { 
          borderRadius: 3,
          direction: 'rtl'
        } 
      }}
    >
      {/* Custom Dialog Header with Close Button */}
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        p: 2,
        borderBottom: '1px solid #e0e0e0'
      }}>
        <Typography 
          variant="h6" 
          sx={{ 
            fontWeight: 'bold',
            color: '#0f3662'
          }}
        >
          اختار المقاس
        </Typography>
        <IconButton 
          onClick={onClose}
          sx={{ 
            color: '#666',
            '&:hover': { bgcolor: '#f5f5f5' }
          }}
        >
          <Close />
        </IconButton>
      </Box>
      
      <DialogContent sx={{ py: 3 }}>
        <Typography 
          variant="body1" 
          sx={{ 
            textAlign: 'right',
            mb: 2,
            color: '#333',
            fontWeight: 'bold'
          }}
        >
          المقاس:
        </Typography>
        
        <Box sx={{ 
          display: 'flex', 
          gap: 1.5, 
          flexWrap: 'wrap',
          justifyContent: 'flex-end',
          flexDirection: 'row-reverse',
          width: '100%',
          mt: 1
        }}>
          {availableSizes.map(sizeItem => (
            <Button 
              key={sizeItem.id}
              variant="outlined"
              onClick={() => onSizeChange(sizeItem.size)}
              disabled={sizeItem.stock < 1}
              sx={{
                minWidth: 60,
                height: 48,
                borderRadius: 2,
                fontWeight: 'bold',
                ...(selectedSize === sizeItem.size && {
                  backgroundColor: '#0f3662',
                  color: '#ffffff',
                  '&:hover': { backgroundColor: '#0f3662' }
                }),
                ...(selectedSize !== sizeItem.size && {
                  borderColor: '#0f3662',
                  color: '#0f3662',
                  '&:hover': {
                    borderColor: '#0f3662',
                    backgroundColor: 'rgba(15, 54, 98, 0.04)'
                  }
                })
              }}
            >
              {sizeItem.size}
            </Button>
          ))}
        </Box>
        
        <Box sx={{ textAlign: 'center', mt: 3 }}>
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={() => {
              onClose();
              onAddToCart();
            }}
            disabled={!selectedSize}
            sx={{
              py: 1.5,
              fontSize: '1rem',
              fontWeight: 'bold',
              backgroundColor: '#0f3662',
              borderRadius: 2,
              '&:hover': { 
                backgroundColor: '#0a2a4a'
              },
              '&:disabled': { 
                backgroundColor: '#ccc'
              }
            }}
          >
            أضف إلى السلة
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SizeSelectionDialog;